import { Spinner } from '@celltrak/ui-components';

import { onlyLettersAndHyphen } from '../../constants';

import UserNameField from './UserNameField';
import PasswordField from './PasswordField';
import NodePicker from './NodePicker';
import MedicaidField from './MedicaidField';
import BusinessNameField from './BusinessNameField';
import EntityIdField from './EntityIdField';
import NpiField from './NpiField';
import TaxonomyField from './TaxonomyField';
import EinField from './EinField';
import ClaimLayoutName from './ClaimLayoutNameField';
import EmailField from './EmailField';
import VendorIdField from './VendorIdField';
import IncludeBillingToggle from './IncludeBillingToggle';
import SplitVisitToggle from './SplitVisit';
import CancelButton from './CancelButton';
import SaveButton from './SaveButton';
import useCredentialForm from './CredentialForm.hooks';
import styles from './CredentialForm.module.scss';

const CredentialForm = () => {
  const {
    values,
    handleToggleChange,
    handleValueChange,
    isFormLoading,
    handleCancel,
    handleSave,
    nodePickerOptions,
    isSaveDisabled,
    spinnerMessage,
  } = useCredentialForm();

  const renderSpinner = () => (
    <div className={styles.spinnerContainer}>
      <Spinner color="primary">{spinnerMessage}</Spinner>
    </div>
  );

  const renderForm = () => (
    <form className={styles.userForm} autoComplete="off">
      <div className={styles.fields}>
        <div className={styles.row}>
          <UserNameField
            value={values.payerUsername}
            onChange={handleValueChange('payerUsername')}
            restrictions={onlyLettersAndHyphen}
          />
          <PasswordField
            value={values.payerPassword}
            onChange={handleValueChange('payerPassword')}
          />
        </div>
        <div className={styles.row}>
          <NodePicker
            value={values.aggregatorID}
            onChange={handleValueChange('aggregatorID')}
            options={nodePickerOptions}
          />
          <MedicaidField
            value={values.businessMedicaidID}
            onChange={handleValueChange('businessMedicaidID')}
          />
        </div>
        <div className={styles.row}>
          <BusinessNameField
            value={values.businessName}
            onChange={handleValueChange('businessName')}
          />
          <EntityIdField
            value={values.businessEntityID}
            onChange={handleValueChange('businessEntityID')}
          />
        </div>
        <div className={styles.row}>
          <NpiField value={values.businessNPI} onChange={handleValueChange('businessNPI')} />
          <TaxonomyField
            value={values.businessTaxonomy}
            onChange={handleValueChange('businessTaxonomy')}
          />
        </div>
        <div className={styles.row}>
          <EinField value={values.businessEIN} onChange={handleValueChange('businessEIN')} />
          <ClaimLayoutName
            value={values.claimLayoutName}
            onChange={handleValueChange('claimLayoutName')}
          />
        </div>
        <div className={styles.row}>
          <EmailField value={values.email} onChange={handleValueChange('email')} />
          <VendorIdField value={values.vendorID} onChange={handleValueChange('vendorID')} />
        </div>
        <IncludeBillingToggle
          isChecked={values.includeBilling}
          onChange={handleToggleChange('includeBilling')}
        />
        <SplitVisitToggle
          isChecked={values.splitVisit}
          onChange={handleToggleChange('splitVisit')}
        />
      </div>

      <div className={styles.formActions}>
        <CancelButton onClick={() => handleCancel()} />
        <SaveButton onClick={() => handleSave()} disabled={isSaveDisabled} />
      </div>
    </form>
  );

  return isFormLoading ? renderSpinner() : renderForm();
};

export default CredentialForm;
